import React from 'react';
import { useField } from 'formik';
import TextField from '@material-ui/core/TextField';

const CustomInput = (props) => {
  const { name, ...rest } = props;
  const [field, meta] = useField(name);

  const hasError = !!(meta.touched && meta.error);

  return (
    <div>
      <TextField
        variant="outlined"
        margin="normal"
        fullWidth
        error={hasError}
        helperText={hasError ? meta.error : undefined}
        {...field}
        {...rest}
      />
    </div>
  )
};

export default CustomInput;
